import React from 'react';
import { Card as JoyCard, CardContent, CardOverflow, AspectRatio } from '@mui/joy';
import { cn } from '@utils/cn';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'outlined' | 'soft' | 'solid' | 'plain';
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning';
  size?: 'sm' | 'md' | 'lg';
  cover?: string;
  aspectRatio?: string;
  onClick?: () => void;
  hoverable?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  variant = 'outlined',
  color = 'neutral',
  size = 'md',
  cover,
  aspectRatio = '16/9',
  onClick,
  hoverable = false,
}) => {
  return (
    <JoyCard
      variant={variant}
      color={color}
      size={size}
      onClick={onClick}
      className={cn(
        'transition-all duration-300',
        hoverable && 'hover:shadow-lg hover:-translate-y-1 cursor-pointer',
        onClick && 'cursor-pointer',
        className
      )}
    >
      {cover && (
        <CardOverflow>
          <AspectRatio ratio={aspectRatio}>
            <img
              src={cover}
              alt=""
              className="object-cover w-full h-full"
            />
          </AspectRatio>
        </CardOverflow>
      )}
      <CardContent>{children}</CardContent>
    </JoyCard>
  );
};